export const SET_CART_ITEM = 'SET_CART_ITEM';

/**
 * This action is used to set specfic quantities for existing line items
 * @param {string} inventoryLevelId The inventoryLevelId to set quantity for
 * @param {number} quantity The quantity to reduce from the cart
 * @returns An action object of the specified type and payload
 */

const setCartItem = (inventoryLevelId, quantity) => {
    return {
        type: SET_CART_ITEM,
        payload: {
            inventoryLevelId,
            quantity,
        },
    };
};

export default setCartItem;